// permissionsService.js
import { generateRouteAndPermissions } from "../helper/com-helper";
import { BAR_MENU } from "../utils/const";
import { GENAI } from "../utils/RouteHelper/GENAI";

export const checkRoutePermissions = (path, userPermissions) => {
  const menuPathWithPermissions = generateRouteAndPermissions(
    [...Object.values(BAR_MENU), GENAI]
  );
  const route = menuPathWithPermissions[path];
  if (route && route.permissions.some((r) => userPermissions.includes(r))) {
    return true;
  }
  return false;
};
